import {
  AdditionalWorkingStepDto,
  JsonSchema,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export interface AdditionalWorkingStepFormConfiguration {
  jsonSchema: JsonSchema
  uiSchema: JsonSchema
  formData: unknown
}

export function AdditionalWorkingStepFormModelBuilder() {
  const FromAPIResponse = (
    resp: AdditionalWorkingStepDto
  ): AdditionalWorkingStepFormConfiguration => {
    const model: AdditionalWorkingStepFormConfiguration = {
      jsonSchema: JSON.parse(resp.jsonSchema.replace(/\r?\n|\r/g, '')),
      formData: resp.formData,
      uiSchema: JSON.parse(resp.uiSchema?.replace(/\r?\n|\r/g, '')),
    }

    delete model.jsonSchema['$schema']

    // needs to fix the QuantityDto definition to allow additionalProperties
    if (model.jsonSchema?.definitions?.QuantityDto) {
      // model.jsonSchema.definitions.QuantityDto.additionalProperties = true
    }

    return model
  }

  return {
    FromAPIResponse,
  }
}
